import { useQuery } from '@tanstack/react-query';
import { Modal, Skeleton, StatusHint } from '@indipia/ui-core';
import { fetchSite } from './api';
import { StepC } from './StepC';
import type { StepBResult } from './types';

interface FloorPlanRegistrationPopupProps {
  siteId: number;
  onClose: () => void;
  onComplete?: (siteId: number) => void;
}

/**
 * 도면 등록 단독 팝업 — Step C를 siteId 하나로 직접 진입
 * (현장 등록 3단계 없이 도면만 등록할 때 사용)
 */
export function FloorPlanRegistrationPopup({
  siteId,
  onClose,
  onComplete,
}: FloorPlanRegistrationPopupProps) {
  const { data: site, isLoading } = useQuery({
    queryKey: ['site', siteId],
    queryFn: () => fetchSite(siteId),
    staleTime: 60_000,
  });

  // site 로딩 전 stepBResult 구성 — StepC 내부에서도 같은 siteId로 재조회함
  const stepBResult: StepBResult = {
    siteId,
    bldgId: site?.bldgId ?? null,
    roadAddress: site?.siteAddress ?? '',
    sitePyeong: site?.sitePyeong ?? null,
    squareMeters: null,
    bldgName: site?.bldgName ?? null,
    addressDong: site?.addressDong ?? null,
    addressHo: site?.addressHo ?? null,
  };

  return (
    // 딤·포커스 트랩·Esc·scrim 클릭·포커스 복원은 공용 Modal 이 갖는다 (D-09 §15.6)
    <Modal open onClose={onClose} title="도면 등록" size="lg">
      <div className="mb-3">
        {isLoading
          ? <Skeleton variant="text" width={160} />
          : <StatusHint tone="muted">현장 #{siteId}{site?.bldgName ? ` · ${site.bldgName}` : ''}</StatusHint>}
      </div>

      {/* .modal-body 는 스크롤 컨테이너가 아니므로 본문 높이를 여기서 제한한다 */}
      <div className="max-h-[60vh] overflow-y-auto">
        <StepC
          stepBResult={stepBResult}
          onPrev={onClose}
          onComplete={(sid) => {
            onComplete?.(sid);
            onClose();
          }}
          onClose={onClose}
        />
      </div>
    </Modal>
  );
}
